var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    viewBox: "0 0 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.228 0.695516C22.9453 0.392841 22.4707 0.376707 22.168 0.65948C21.8653 0.942254 21.8492 1.41685 22.132 1.71953L27.0229 6.95474H11.75C11.7485 6.95474 11.747 6.95474 11.7456 6.95475L2.47707 6.95475L7.36804 1.71954C7.65082 1.41687 7.63468 0.942267 7.33201 0.659494C7.02933 0.376721 6.55473 0.392855 6.27196 0.69553L0.201958 7.19274C-0.0673194 7.48097 -0.0673194 7.92853 0.201958 8.21676L6.27196 14.714C6.55473 15.0166 7.02933 15.0328 7.33201 14.75C7.63468 14.4672 7.65082 13.9926 7.36804 13.69L2.47707 8.45475L17.75 8.45475C17.7515 8.45475 17.753 8.45475 17.7545 8.45474H27.0229L22.132 13.6899C21.8492 13.9926 21.8653 14.4672 22.168 14.75C22.4707 15.0328 22.9453 15.0166 23.228 14.714L29.298 8.21674C29.5673 7.92851 29.5673 7.48096 29.298 7.19273L23.228 0.695516Z",
    fill: "#AD8D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatIcon);
export default __webpack_public_path__ + "static/media/flatIcon.abbda2ca.svg";
export { ForwardRef as ReactComponent };